
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/helpHome/styles.scss.css.virtualfile';
        module.exports = {"blocks":"_blocks_1kel4_7","list":"_list_1kel4_15"};